import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import { StorageHttpClient } from '../common/storage-http/storage-http.client';
import {ENV} from "../../../environments/environment";
import {CONSTANTS} from "../../../environments/common";

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {

  constructor(private http: HttpClient, private storageHttp: StorageHttpClient) { }

  getCatalogueLanguages(catalogueId) {
    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE.GET_PROFILES + '/' + catalogueId + '/' + 'languages';
    return this.http.get(url);
  }

  getCatalogueDefaultLanguages(catalogueId) {
    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.CATALOGUE.GET_PROFILES + '/' + catalogueId + '/' + 'languages/default';
    return this.http.get(url);
  }

  getRemoteCustomTranslationsJson(dataIn, local = false) {
    const time:number = Date.now();
    let urlMedia = ENV.APP.STORAGE_REPOSITORY + CONSTANTS.END_POINTS.MEDIA.ECATALOGUE + '/' + dataIn.sapCode + '/lang/' + dataIn.lang + '.json?t=' + time;
    return this.storageHttp.get(urlMedia);
  }

}
